import { render, staticRenderFns } from "./StatisticsOverview.vue?vue&type=template&id=55c2e86a&scoped=true&"
import script from "./StatisticsOverview.vue?vue&type=script&lang=js&"
export * from "./StatisticsOverview.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsOverview.vue?vue&type=style&index=0&id=55c2e86a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c2e86a",
  null
  
)

export default component.exports